<template>
    <div :class="'page '+(is_media_play?'flex-direction':'')"
         v-if="is_body_show"
         @scroll="bodyScroll"
         :style="'height:'+innerHeight+'px'">
        <div class="music" v-show="curriculum_audio_detail.length == 0">
            <div class="cover">
                <van-image :src="params.cover" :height="videoHeight" ref="musicImg" fit="cover" class="cover-img"  />
            </div>
        </div>
        <div class="music" v-if="curriculum_audio_detail.mates_type == 1">
            <audio autoplay="autoplay" id="audioPlayer" preload="auto" :src="curriculum_audio_detail.mates_path">
                你的浏览器不支持audio标签
            </audio>
            <div class="cover">
                <van-image :src="params.cover" :height="videoHeight"  class="cover-img" fit="cover" />

                <div class="cell position-a">
                    <!--播放按钮-->
                    <div class="tools ml10 " @click="playAudio" v-show="!isPlay">
                        <span class="iconfont iconbofang11"></span>
                    </div>
                    <!--暂停按钮-->
                    <div class="tools ml10" @click="pauseAudio" v-show="isPlay">
                        <span class="iconfont iconbofang1"></span>
                    </div>

                    <div class="cell__bd line_p">
                        <van-slider class='slider'
                                    :disabled="params.is_own == 0?true:false"
                                @change="sliderChange"
                                v-model="audioTime"/>
                        <!--<div class="line"></div>-->
                        <!--<div class="line line2" style="{{ 'width:'+ (int_time/int_max_time*100) + '%' }}"></div>-->
                        <!--<div class="dian" style="{{ 'left:'+ (int_time/int_max_time*100) + '%' }}"></div>-->
                    </div>
                    <div class="time">
                        {{audioCurrentTime}}/{{audioAllTime}}
                    </div>
                </div>
            </div>
        </div>

        <div class="video-content" v-if="curriculum_audio_detail.mates_type == 2" v-show="!taolun_discuss_show" >
            <video-player class="video-player vjs-custom-skin"
                          ref="videoPlayer"
                          id="videoPlayer"
                          :playsinline="true"
                          style="object-fit:fill"
                          :options="playerOptions"
                          @play="onPlayerPlay($event)"
                          @pause="onPlayerPause($event)"
                          @timeupdate="onPlayerTimeUpdate($event)"
            ></video-player>
        </div>

        <div class="pdf-content" v-if="curriculum_audio_detail.mates_type == 4" style="position:relative">
            <van-swipe class="swiper banner-class"
                       :show-indicators="false"
                       @change="pdfChange"
                       :height="videoHeight"
                       >
                <van-swipe-item v-for="(item, index) in curriculum_audio_detail.pdf_json_lists" :key="index">
                    <van-image
                            @click="pdfImagePreview(index)"
                            lazy-load
                            :src="item+'?x-oss-process=style/w750'"
                            style="width:100%;height:100%"
                            fit="contain"
                    />
                </van-swipe-item>
            </van-swipe>

            <div class="pdf-text">
                {{pdf_current}} / {{curriculum_audio_detail.pdf_json_lists.length}}
            </div>
        </div>

        <div class="resources" :style="'border-bottom:'+ (curriculum_list.length==0?'1px':'0'+' solid #eee')">
            <div class="course-time" v-if="curriculum_list.length > 0">
                {{curriculum_audio_detail.online_time_cn}} | {{curriculum_audio_detail.play_times || 0}} 次学习
            </div>
            <div class="course-time" v-else>
                {{params.create_time}} | {{params.view_count || 0}} 次浏览
            </div>
            <div class="resources-event">
                <div class="event-info bs" @click="changeMultiple" v-if="curriculum_audio_detail.mates_type == 1">
                    <div class="cell_t">{{multipleArray[multipleIndex]}}X</div>
                    <div class="cell_b hide">倍数</div>
                </div>
                <div class="event-info sc" @click="saveColCal">
                    <span class="iconfont iconcollection-b cell_t" :style="params.is_collect==0?'color:#999999':''"></span>
                    <div class="cell_b hide">{{params.is_collect==1?'已':''}}收藏</div>
                </div>
                <div class="event-info zf" @click="btnForwardEvent" v-if="posterShow">
                    <span class="iconfont iconzhuanfa cell_t"></span>
                    <div class="cell_b hide">转发</div>
                </div>
            </div>
        </div>

        <div class="flex">
            <div class="table"> <!--{{isFixedTop?'fixed':''}}-->
                <div :class="type=='XiangQing'?'tab-li curr':'tab-li'" @click="bindType" data-type="XiangQing">详情</div>
                <div :class="type=='ZhangJieYuGao'?'tab-li curr':'tab-li'" @click="bindType" data-type="ZhangJieYuGao">章节</div>
                <div :class="type=='HuDong'?'tab-li curr':'tab-li'" @click="bindType" data-type="HuDong" v-if="params.is_own != 0 && works_list.cnt > 0 ">作业</div>
                <div :class="type=='KaoShi'?'tab-li curr':'tab-li'" @click="bindType" data-type="KaoShi" v-if="params.is_testing && params.is_own != 0">考试</div>
            </div>
            <div class="table-content">
                <div class="table-content-xiangqing" v-show="type=='XiangQing'">
                    <div v-html="params.content"></div>
                </div>

                <div class="table-content-xiangqing table-content-zhangjieyugao" v-show="type=='ZhangJieYuGao'">

                    <div class="audio-list" id="scroll">
                        <div v-for="(item,index) in curriculum_list" :id="'navItem'+index" :key="item.sections_id"
                             :data-current="index"
                             :class="'i-class i-tabs-tab i-tabs-tab-scroll '+ (currentTab==index ? 'i-tabs-tab-current' : '' )"
                             @click="handleChangeScroll($event, item)" :data-key="item.sections_id">
                            <div>
                                <div :class="'i-tabs-tab-title '+ (currentTab==index  ? 'i-tabs-tab-title-current' : '' )" v-if="currentTab==index ">{{ item.name }}</div>
                                <div :class="'i-tabs-tab-title '+ (currentTab==index  ? 'i-tabs-tab-title-current' : '' )" v-else>{{ item.name }}</div>
                            </div>
                            <div class="i-tabs-tab-bottom">
                                <div class="i-tabs-tab-doc">
                                    <div class="i-tabs-tab-doc" v-if="currentTab==index " style="font-size:10px">
                                        <span class="iconfont iconbofang11"></span>
                                        正在播放
                                    </div>
                                    <div class="i-tabs-tab-doc" v-if="currentTab!=index && item.last_play_position>0 && item.last_play_position<item.mates_duration" style="font-size:10px">
                                        已播放{{item.time_percentage}}%
                                    </div>
                                    <div class="i-tabs-tab-doc" v-if="currentTab!=index && item.last_play_position>0 && item.last_play_position>=item.mates_duration" style="font-size:10px">
                                        <span class="iconfont icondagou-xianxing"></span>
                                        已播完
                                    </div>
                                </div>
                                <div class="i-tabs-tab-doc tr">{{item.mates_duration_cn}}</div>
                            </div>
                            <div class="time-percentage" :style="'width:'+item.time_percentage+'%'"></div>
                        </div>
                    </div>

                    <div v-show="1" style="padding:10px">
                        <div class="chapter-data">
                            章节资料
                        </div>

                        <div style="margin-top:30px">
                            <div class="wares-li" >
                                <div class="wares-top">
                                    <div class="wares-name">{{curriculum_audio_detail.name}}</div>
                                </div>
                                <div class="wares-txt">
                                    {{curriculum_audio_detail.description}}
                                </div>
                                <div class="wares-img" v-if="curriculum_audio_detail.mates_ex_pdf_array && curriculum_audio_detail.mates_ex_pdf_array.length>0">
                                    <div class="wares-img-txt">
                                        本章课件 {{curriculum_audio_detail.current || 1}} / {{curriculum_audio_detail.mates_ex_pdf_array.length}}
                                    </div>

                                    <div class="wares-img-list">
                                        <van-swipe class="swiper banner-class"
                                                   :show-indicators="false"
                                                   @change="sectionWaresChange($event)"
                                                   style="height:100%;margin-top:10px">
                                            <van-swipe-item v-for="(items, indexs) in curriculum_audio_detail.mates_ex_pdf_array" :key="indexs">
                                                <van-image
                                                        @click="sectionWaresImagePreview(indexs)"
                                                        lazy-load
                                                        :src="items+'?x-oss-process=style/w750'"
                                                        style="width:100%;height:100%"
                                                />
                                            </van-swipe-item>
                                        </van-swipe>
                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>
                    <div v-show="curriculum_audio_detail.content" style="padding:10px">
                        <div class="chapter-data">
                            课程文稿
                        </div>

                        <div style="margin-top:30px">
                            <div class="audio_detail_content" v-html="curriculum_audio_detail.content"></div>
                        </div>
                    </div>
                </div>

                <div class="table-content-xiangqing" v-show="type=='HuDong'" style="padding: 0">
                    <!--<div class="interaction" @click="bindInteractionEvent">-->
                        <!--<div class="interaction-icon">-->
                            <!--<span class="iconfont iconjiaoyu"></span>-->
                        <!--</div>-->
                        <!--<div class="interaction-content">-->
                            <!--<div>作业</div>-->
                            <!--<div class="inter-txt">关联了{{works_list.cnt || 0}}个作业</div>-->
                        <!--</div>-->
                    <!--</div>-->
                    <course_work :work_book_id="works_list.work_book_id"
                                 :is_scroll="is_scroll"
                                 :scroll_top="scrollTop"
                                 :mates_poster="params.cover"
                                 :w_b_id="work_busy_id"
                                 v-on:myworkparams="bindmyworkparams"
                                 v-on:workchatparams="bindworkchatparams"
                                 id="courseWork"
                                 ref="courseWork"
                                 v-if="works_list.cnt > 0" ></course_work>

                    <div v-if="works_list.cnt == 0">
                        <van-empty description="暂无作业~" />
                    </div>
                </div>

                <div class="table-content-xiangqing" v-show="type=='KaoShi'"  style="padding: 0"  v-if="params.is_testing">
                    <div class="cover" v-if="testing_params.cover_url">
                        <van-image :src="testing_params.cover_url" fit="contain" class="cover-img"/>
                    </div>
                    <div class="ks-question">
                        {{testing_params.name}}
                    </div>
                    <div class="ks-user" v-if="testing_params.checked_num > 0">
                        <div class="ks-user-logo">
                            <img :class="'ks-user-img '+(index >0?'mlf15':'')" v-for="(item,index) in testing_params.test_users"
                                 :src="item.photo"/>
                        </div>
                        <div class="ks-user-col">
                            等{{testing_params.checked_num}}人参与
                        </div>
                    </div>
                    <div class="chapter-data">
                        考试信息
                    </div>
                    <div class="ks-info">
                        <div class="ks-info-col">
                            <div class="ks-info-number">{{testing_params.limit_duration}}</div>
                            <span class="ks-info-txt">考试时长（分钟）</span>
                        </div>
                        <div class="ks-info-col">
                            <div class="ks-info-number">{{testing_params.question_num}}</div>
                            <span class="ks-info-txt">题目量（题）</span>
                        </div>
                        <div class="ks-info-col">
                            <div class="ks-info-number">{{testing_params.score}}</div>
                            <span class="ks-info-txt">考试总分（分）</span>
                        </div>
                    </div>
                    <div class="bj"></div>

                    <div class="chapter-data">
                        考试详情
                    </div>
                    <div class="ks-content">
                        <div v-html="testing_params.detail"></div>
                    </div>

                    <div class="ks-btn" @click="bindGotoTesting">
                        <div class="ks-btn-col" v-if="testing_params.user_status == 0">开始考试</div>
                        <div class="ks-btn-col" v-if="testing_params.user_status == 1">继续考试</div>
                        <div class="ks-btn-col" v-if="testing_params.user_status == 2 || testing_params.user_status == 3">查看成绩</div>
                    </div>
                </div>
            </div>
        </div>


        <div class="collect-info" v-if="is_collect_info" @click="bindGotoCollectInfoIndex">
            <img src="https://o-yzx.bysjy.com.cn/notice/1593770853-1832.gif" style="width:90px;height:50px"/>
        </div>

        <div class="mask" v-if="is_mask">
            <div class="topic">
                <div class="topic-title" v-if="answer_list.length == 0">
                    随堂测验

                    <div class="topic-close" v-if="!question_list.is_force" @click="bindQuestionCloseMask">
                        关闭
                    </div>
                </div>

                <div class="topic-title align-c" v-if="answer_list.length > 0">

                    <span class="yes" v-if="answer_list[question_idx].result_answer">你答对了</span>
                    <span class="no" v-if="!answer_list[question_idx].result_answer">你答错了</span>

                    <div class="topic-close" v-if="!question_list.is_force" @click="bindQuestionCloseMask">
                        关闭
                    </div>
                </div>
                <div class="topic-frameli">
                    第<span>{{question_idx+1}}</span>/{{question_list[question_test_time].length}}题
                </div>
                <div class="entrance-bottom-frame">
                    <div class="entrance-bottom-frame-line" v-for="(item,index) in question_list[question_test_time]" :key="index">
                        <div v-if="index == question_idx">
                            <div class="entrance-bottom-frame-line-title">【{{item.question_type_cn}}】{{item.question}}</div>

                            <div v-for="(items,index_2) in item.question_options"
                                 :key="index_2">

                                <div :class="'entrance-bottom-frame-line-button '+ (!!question_set_list[question_idx] && !!question_set_list[question_idx].question_options_id && items.question_options_id == question_set_list[question_idx].question_options_id?'sel':'')"
                                     @click="bindQuestionSingleButton" :data-id="items.question_options_id" v-if="item.question_type==1">{{items.options}}</div>

                                <div :class="'entrance-bottom-frame-line-button '+(!!question_set_list[question_idx] && !!question_set_list[question_idx].answer && question_set_list[question_idx].answer.indexOf(items.question_options_id)>-1?'sel':'')"
                                     @click="bindQuestionManyButton" :data-id="items.question_options_id" v-if="item.question_type==2">{{items.options}}</div>

                                <div>
                                    <div :class="'entrance-bottom-frame-line-button '+(!!question_set_list[question_idx]&&!!question_set_list[question_idx].answer && question_set_list[question_idx].answer==1?'sel':'')"
                                         @click="bindQuestionJudgeButton" :data-id="items.question_options_id" data-is_true="1" v-if="item.question_type==3">正确</div>

                                    <div :class="'entrance-bottom-frame-line-button '+(!!question_set_list[question_idx]&&!!question_set_list[question_idx].answer && question_set_list[question_idx].answer==0?'sel':'')"
                                         @click="bindQuestionJudgeButton" :data-id="items.question_options_id" data-is_true="0" v-if="item.question_type==3">错误</div>
                                </div>

                                <div class="entrance-bottom-frame-line-button"
                                     v-if="item.question_type==4">
                                    <input type="text" class="input-text" :data-id="items.question_options_id" :data-index="index_2" @input="bindQuestionBlanksButton" :placeholder="'请输入第'+(index_2+1)+'空答案'" :value="!!question_set_list[question_idx] && !!question_set_list[question_idx].answer && !!question_set_list[question_idx].answer[index_2]?question_set_list[question_idx].answer[index_2]:''" />
                                </div>

                                <div class="entrance-bottom-frame-line-button" v-if="item.question_type==5">
                                    <textarea maxlength="10000" class="input-textarea" :data-id="items.question_options_id" @input="bindQuestionQAInputButton($event)" placeholder="请输入答案" :value="!!question_set_list[question_idx] && !!question_set_list[question_idx].answer?question_set_list[question_idx].answer:''"></textarea>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
                <div class="topic-btn">
                    <div class="btn upper" v-if="question_idx>0" @click="bindUpperLower">上一题</div>
                    <div class="btn" v-else=""></div>

                    <div class="btn save" v-if="question_idx == question_list[question_test_time].length-1 && answer_list.length == 0" @click="bindQuestionSave">提交</div>
                    <div class="btn" v-else=""></div>

                    <div class="btn lower" v-if="question_idx<question_list[question_test_time].length-1" @click="bindQuestionLower">下一题</div>
                    <div class="btn" v-else=""></div>
                </div>
            </div>
        </div>

        <template v-if="type=='XiangQing'" >
        <!--免费-->
        <div class="make-an-appointment" v-if="params.sell_mode == 2 && params.is_own == 0">
            <div class="make-an-appointment-text" style="background-color:#00CC00" @click="bandOrder">立即领取</div>
        </div>

        <!-- 购买 -->
        <div class="make-an-appointment" v-if="params.sell_mode == 1 && params.is_own == 0">
            <div class="share" @click="is_show_share = true"><span class="iconfont iconfenxiang"></span></div>
            <div class="trial-class" style="display:none">试课</div>

            <div class="make-an-appointment-text" v-if="params.is_own == 0" @click="bindApply">立即购买（￥ {{params.money}}）</div>
            <div class="make-an-appointment-text" style="background-color:#00CC00" v-if="params.is_own == 1">已购买</div>
        </div>
        </template>

        <share :is_show_share="is_show_share" v-on:hideShare="hideShare"></share>

        <!--讨论区-->
        <div v-show="type=='ZhangJieYuGao'">
            <div class="taolun-btn">
                <div class="taolun-btn-text">
                    <van-field
                            rows="1"
                            left-icon="edit"
                            autosize
                            type="text"
                            readonly
                            placeholder="写留言, 与作者互动"
                            @click="bandTaolunFocus"
                    />
                </div>

                <div class="taolun-discuss-module" >
                    <van-icon :name="taolun_summary.is_favor_course?'good-job':'good-job-o'" :badge="taolun_summary.favor_count"  color="#1989fa" size="25" @click="bindTaolunCourseFavor" />
                </div>
                <div class="taolun-favor-module" >
                    <van-icon  name="chat-o"  :badge="taolun_summary.reply_count"  color="#1989fa" size="25" @click="bindTaolunDisBtn" />
                </div>

            </div>
            <!-- 发表讨论 -->
            <van-popup
                    v-model="taolun_text_show"
                    @opened="bindTaolunPubTextOpen"
                    position="bottom"
                    :style="{ height: '70%', borderRadius: '7px 7px 0 0' }"
            >
                <div class="taolun-text-wrap">
                    <div class="taolun-text-head">
                        <div><van-icon name="close" size="24" @click="bandTaolunClose" /></div>
                        <div class="taolun-text-head-title">写评论</div>
                        <div>
                            <van-button size="mini" round type="info" color="linear-gradient(to right, #FEB400, #FEB400)" :style="{padding:'0 7px'}" @click="bindTaolunPublish" >发布</van-button>
                        </div>
                    </div>
                    <div>
                        <van-field
                                rows="10"
                                type="textarea"
                                maxlength="500"
                                ref="taolun_content"
                                v-model="taolun_sub.content"
                                placeholder="请输入评论"
                                show-word-limit
                        />
                    </div>
                    <div class="taolun-text-bottom">
                        <div class="taolun-text-bottom-left" >
                            <div class="iconfont_wrap" ><span @click="bindImageClick()"  class="iconfont iconcomiistupian mr5 size25"></span></div>
                            <div class="iconfont_wrap" style="display: none"  @click="bindRecordClick(index)"><span class="iconfont iconyinpin mr5 size25"></span></div>
                        </div>
                        <div v-if="this.taolun_sub.privacy_status==1" class="taolun-text-right" @click="bindPrivacyClick()" >
                            <span class="iconfont iconyanjing_kai size21"></span>
                            <span style="font-size: 11px;">公开</span>
                        </div>
                        <div v-if="this.taolun_sub.privacy_status==3" class="taolun-text-right right-privacy" @click="bindPrivacyClick()" >
                            <span class="iconfont iconyanjing-bi size21"></span>
                            <span style="font-size: 11px;">保密</span>
                        </div>
                    </div>
                    <div class="taolun-image-upload">
                        <van-uploader
                                ref="taolun_upload"
                                v-model="taolun_filelist"
                                multiple
                                :after-read="afterRead"
                                :max-count="9"
                        />
                    </div>
                </div>
            </van-popup>

            <!-- 讨论列表 -->
            <van-popup
                    v-model="taolun_discuss_show"
                    position="bottom"
                    @opened="bindTaolunDisOpen"
                    :style="{ height: '100%' }"
            >
                <div class="taolun_discuss_list_zone"  >
                    <van-nav-bar
                            title="精选评论"
                            @click-left="bindTaolunDisClose"
                    >
                        <template #left>
                            <van-icon color="#CFCFCF" name="close" size="18" />
                        </template>
                    </van-nav-bar>
                    <div class="taolun_discuss_list">
                        <course_discuss
                                :course_id="course_id"
                                :course_name="params.name"
                                id="courseDiscuss"
                                ref="courseDiscuss"
                                :is_scroll="is_scroll"
                                :scroll_top="scrollTop"
                                v-on:myworkparams="bindmyworkparams"
                                v-on:workchatparams="bindworkchatparams"
                        >
                        </course_discuss>
                    </div>
                </div>
            </van-popup>
        </div>

        <authorize_mobile ref="authorize_mobile" v-on:usergrantcallback="usergrantcallback" :visible="visible"></authorize_mobile>
    </div>
</template>

<script>
    var audioInterval,duration_time_Interval;
    var WeChat;
    import { Slider,Tab,Button,Tabs,Lazyload,Field,Icon,Image as VanImage ,Swipe, SwipeItem,List,ImagePreview,Empty,Popup,NavBar,Uploader} from 'vant';
    import share from '../../components/common/share';
    import course_work from '../../components/common/course_work';
    import course_discuss from '../../components/common/course_discuss';
    import env from '../../utils/env'
    import authorize_mobile from '../../components/common/authorize_mobile';

    export default {
        name: "index",
        components:{
            [Slider.name]:Slider,
            [Tab.name]:Tab,
            [Tabs.name]:Tabs,
            [VanImage.name]:VanImage,
            [Swipe.name]: Swipe,
            [Icon.name]:Icon,
            [SwipeItem.name]: SwipeItem,
            [List.name]:List,
            [Empty.name]:Empty,
            share,
            course_work,
            course_discuss,
            [Field.name]:Field,
            [Popup.name]:Popup,
            [Button.name]:Button,
            [NavBar.name]:NavBar,
            [Uploader.name]:Uploader,
            authorize_mobile
        },
        data(){
            return {
               visible:false,
                is_show_share:false,
                is_body_show:false,
                is_media_play:true,
                course_id:'',
                current:'',
                currents:'',
                currentTab:0,
                navScrollLeft:0,
                this_url:'',
                type:'ZhangJieYuGao',
                total:0,
                page:1,
                page_zuo:1,
                page_you:1,
                pageSize:10,
                params:[],
                videoHeight: 239,
                innerHeight:0,//整体高度
                curriculum_list:[],
                curriculum_audio_detail:[],
                duration_time:0, // 学习时间
                posterShow:false,//转发按钮显示
                current_page:1,
                scrollIndex:0,
                scrollX:0,//记录滚动条位置
                scrollXS:0,//初始记录
                is_allow_scroll:true,
                is_collect_info:false,//报名
                ddrps_id:'',
                perform_once:false,
                //音频1
                audioTime:0,//音频进度百分比
                audioCurrentTime:'00:00',//音频当前播放时间
                audioAllTime:'00:00',//音频总播放时间
                audioAllDuration:0,//音频总播放秒数
                isPlay:false,//是否正在播放
                multipleArray:[0.5,1,1.25,1.5,2],//倍数
                multipleIndex:1,//倍数下标
                is_continue:false,//是否自动播放
                //随堂测验
                is_mask:false,//是否显示答题
                answer_list:[], // 正确答案
                question_list:[],
                question_idx:0,
                question_test_time:'',
                question_test_time_list:{},
                question_set_list:[],
                is_question_load:false,
                works_list:[], //课程作业
                // 视频播放
                playerOptions : {
                    playbackRates : [1.0, 1.5, 2.0], //可选择的播放速度 0.5, 1.0, 1.5, 2.0
                    autoplay : true, //如果true,浏览器准备好时开始回放。
                    muted : false, // 默认情况下将会消除任何音频。
                    loop : false, // 视频一结束就重新开始。
                    preload : 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                    language : 'zh-CN',
                    aspectRatio : '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                    fluid : true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                    sources : [ {
                        type : "",
                        src : ''//url地址
                    } ],
                    height:'',
                    poster : "", //你的封面地址
                    controls:true, // 是否显示控件
                    // width: document.documentElement.clientWidth,
                    notSupportedMessage : '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
                    controlBar : {
                        timeDivider : true,//当前时间和持续时间的分隔符
                        durationDisplay : true,//显示持续时间
                        remainingTimeDisplay : false,//是否显示剩余时间功能
                        fullscreenToggle : true  //全屏按钮
                    }
                },
                //图文
                pdf_current:1,
                //课件
                wares_page:1,
                wares_total:0,
                wares_list:[],
                loading: false,
                finished: false,

                //作业
                scrollTop:0,
                is_scroll:false,
                isPageScrollTop:false,
                my_work_params:{
                    status:1
                },
                work_chat_params:{},
                buttonTop :0,
                buttonLeft:0,
                work_busy_id:'',

                //考试
                testing_params:{},

                //讨论区
                taolun_text_show: false,
                taolun_discuss_show: false,
                taolun_sub:{
                    course_id: "",
                    content: "",
                    res_type: "",
                    res_datas: "",
                    privacy_status: 1
                },
                taolun_filelist:[],
                taolun_summary: {
                    favor_count: 0,
                    is_favor_course: 0,
                    reply_count: 0
                },
                //播放位置
                setTimeFlag: 1,
                playtimes: 0
            }
        },
        mounted() {
            this.setCoverDefaultHeight()
            this.course_id = this.util.getQueryStr('course_id');
            this.work_busy_id =this.util.getQueryStr('work_busy_id') || '';
            if(!this.course_id){
                location.href = this.util.urlPrefix+'/curriculum/index?course_id='+this.util.G_CONFIG.find+'&token='+this.util.token;
            }
            this.this_url =  encodeURIComponent(window.location.href);
            this.current = this.util.getQueryStr('current');
            this.currents = this.util.getQueryStr('current');
            this.innerHeight=window.innerHeight;
            var user_id = this.util.getQueryStr('u_id');
            var poster_id =this.util.getQueryStr('p_id');
            var source = 'h5';

            //通过分享链接注册的新用户
            if(user_id && !poster_id){
                localStorage.setItem(this.util.token+'_uId',user_id);
            }
            
            //通过海报进来的用户
            if(user_id && poster_id){
                var poster= {
                    user_id: user_id,
                    poster_id: poster_id
                };
                const _this = this
                //TODO 由于授权会设置本地信息，本地存储信息可能还没有获取到,做个延时
                setTimeout(function () {
                    console.log("本地用户信息：：",_this.util.getUserId.get())
                    if(_this.util.getUserId.get() != '' && _this.util.getUserId.get()!= user_id){
                      _this.util.server.event.event({
                          data: {
                              message:{
                                  poster_id:poster_id,
                                  user_id:_this.util.getUserId.get(),
                                  p_user_id:user_id,
                                  log_id:_this.util.random(32)
                              },
                              code:10020,
                          },
                          callback: (res => {})
                      });
                    }
                    source = 'poster';
                    _this.util.fission_poster.set(poster);
                },500)

            }

            //浏览量+1
            this.util.server.event.event({
                data: {
                    message:{course_id:this.course_id,source:source},
                    code:10000,
                },
                callback: (res => {})
            });

            this.bindWeiXin();

            //如果登录了就自动播放
            if(this.util.sessionid.get() !=''){
                this.is_continue=true
            }

            // 加载作业 ！！！！ 调整从点击tab，变成进入加载
            this.getWorksEvent()
        },
        //离开页面事件
        beforeRouteLeave(to, form, next) {
            form.meta.keepAlive = false;
            clearInterval(audioInterval);
            clearInterval(duration_time_Interval);

            if(this.curriculum_audio_detail.mates_type == 1){
                if(!document.getElementById('audioPlayer').pause()){
                    document.getElementById('audioPlayer').pause();
                }
            }else if(this.curriculum_audio_detail.mates_type == 2){
                if(!document.querySelector('video').pause()){
                    document.querySelector('video').pause()
                }
            }

            this.bindBoFangShiChang();
            next();
        },
        activated(){
            if(this.util.globalData.workEdit.get() == 1){
                this.$refs.courseWork.getDetail();
                this.$refs.courseWork.answerListEvent(1);
            }


        },
        computed: {
            player() {
                return this.$refs.videoPlayer.player
            }
        },
        methods:{
            init(){
                this.bindCurriculumDetail();
                this.bindMiniV1Course(1);
                this.bindIsCollectInfo();
            },
            setCoverDefaultHeight(){
              //根据屏幕宽度计算高度
              var width = document.body.clientWidth>480?480:document.body.clientWidth
              this.videoHeight  = (width*9)/16
              console.log('this.videoHeight',this.videoHeight )
            },
            bindWeiXin:function(){
                var _self=this;
                if(env.wxpcc ||1){
                    _self.init();
                }else{
                    this.util.jweixin(function (wx) {
                        WeChat =wx;

                        // _self.util.wxShare(wx, {
                        //     title: _self.util.G_CONFIG.train_name,
                        //     desc: _self.util.G_CONFIG.desc,
                        //     link: location.href+'&u_id='+_self.util.getUserId.get(),
                        //     imgUrl: _self.util.G_CONFIG.logo
                        // });

                        _self.init();
                    });
                }

            },
            /***************************************图文区域代码 start***********************************************/
            pdfChange:function(index){
                var current = index;
                current +=1;

                this.pdf_current = current;
            },
            pdfImagePreview(index){

                ImagePreview({
                    images:this.curriculum_audio_detail.pdf_json_lists,
                    startPosition:index,
                    closeable: true
                });
            },
            /***************************************图文区域代码 end***********************************************/

            /***************************************课件区域代码 start***********************************************/

            sectionWaresChange(index){
                console.log('111',index)
                var current = index;
                current +=1;

                this.curriculum_audio_detail.current = current;
                this.$forceUpdate();

            },
            sectionWaresImagePreview(imgIndex){
                console.log('2',imgIndex)
                ImagePreview({
                    images:this.curriculum_audio_detail.mates_ex_pdf_array,
                    startPosition:imgIndex,
                    closeable: true
                });
            },
            /***************************************课件区域代码 end***********************************************/

            bindOrderCourse(){
                this.util.server.mini_pay.order_course({
                    data: {
                        type: 1,
                        course_id: this.course_id,
                        pay_money: 0,
                        coupon_user_id: '',
                        sum_money: 0,
                        coupon_money: 0

                    },
                    callback: (res => {
                        if(res.code == 1){
                            location.reload();
                        }
                    })
                })
            },
            bindApply(){

                this.util.payRedirect.set(location.href);
                location.href = this.util.urlPrefix+'/payment/index?id='+this.course_id+'&token='+this.util.token;
                // this.$router.push(this.util.urlPrefix+'/payment/index?id='+this.course_id+'&token='+this.util.token)
            },
            bandOrder(){
                console.log("下订单")
                if(!this.util.user_mobile.get()){
                   this.visible = true;
                   this.$nextTick(() => { 
                        this.$refs.authorize_mobile.focusMoblie();
                   });
                   return 
                }
                //如果是免费 直接进行购买获取。
                if(this.params.sell_mode == 2 && this.params.is_own == 0){
                   this.bindOrderCourse()
                }else{
                    this.util.payRedirect.set(location.href);
                    location.href = this.util.urlPrefix+'/payment/index?id='+this.course_id+'&type=1&token='+this.util.token;
                }
            },
            usergrantcallback(e){
                //绑定手机号码 回调
                this.visible=false;
                if(e.is_grant){
                    this.bandOrder();
                }
            },
            hideShare(e){
                this.is_show_share = e;
            },
            bindWxShare:function(){
                if(!WeChat){
                    return false;
                }
                var _self=this;
                var link = location.href;
                if(location.href.indexOf('&current=') == -1){
                    link = link + '&current='+_self.current+'&u_id='+_self.util.getUserId.get()
                }else{
                    link = 'https://'+location.host+this.util.urlPrefix+'/curriculum/index?course_id='+this.course_id+'&token='+this.util.token+'&current='+this.current+'&u_id='+_self.util.getUserId.get()
                }
                if(_self.params.poster && _self.params.poster.course_poster_id){
                  link += "&p_id=" + params.poster.course_poster_id
                }
                this.util.wxShare(WeChat, {
                    title: _self.params.name,
                    desc: _self.curriculum_audio_detail.name,
                    link: link,
                    imgUrl: _self.params.cover
                });
            },
            handleChangeScroll(e,item){
                console.log('item',item)
                // TODO 暂未考虑试听
                if(this.params.is_own == 0  ){
                    this.util.showToast({
                        message:'请先'+(this.params.sell_mode == 1?'购买':'领取')+'课程'
                    });
                    this.type = 'XiangQing';
                    this.bindSwitch(this.type);
                    return false
                }

                /**
                 * 是否同一个章节 TODO fix 
                 * 解决同一个视频点击
                 * 如果同一个已经暂停,不进行任何处理,如果不是同一个章节则继续执行
                 */
                if(this.current==item.sections_id){
                  return false
                }

                // TODO 这里有个问题, 当媒体资源没有加载完全，audioCurrentTime会为零，会导致资源进度重置为零
                // 修复方案，在获取详细章节时，重置最后位置
                this.curriculum_list[this.scrollIndex].last_play_position=this.util.timeToSec(this.audioCurrentTime);

                this.current = e.currentTarget.dataset.key;//章节ID
                this.is_question_load = false;
                this.scrollIndex =e.currentTarget.dataset.current

                if(this.curriculum_audio_detail.mates_type == 1){
                    if(!document.getElementById('audioPlayer').paused){
                        document.getElementById('audioPlayer').pause();
                    }
                }else if(this.curriculum_audio_detail.mates_type == 2){
                    if(!document.querySelector('video').paused){
                        //TODO 如果重复发送暂停, 视频接受暂停事件,会发送两次观看事件
                        //document.querySelector('video').pause()
                    }
                }
                //重置数据
                clearInterval(audioInterval);
                clearInterval(duration_time_Interval);

                this.switchNav(e);

                //播放音频/视频
                this.bindCurriculumAudioDetail();

                //题目
                this.bindCurriculumQuestionTest();
            },
            //选中块出现在可视区域
            regionShow(id){

                var offsetLeft = document.querySelector('#s'+id).offsetLeft;

                document.querySelector('#scroll').scrollLeft=offsetLeft;
            },
            //收藏
            saveColCal(){
                if(!this.util.isLogin()){
                    return;
                }
                this.util.server.mini_collect.col_cal({
                    data:{
                        object:this.params.type,
                        object_id:this.params.course_id,
                        link:this.util.getCurrentPageUrlWithArgs()
                    },
                    is_show_load:false,
                    callback: (res => {

                        this.util.showToast({
                            message: this.util.CODE.COLLECTION_CODE[res.data.is_collect]
                        });

                        this.params.is_collect=res.data.is_collect;

                    })
                });
            },
            btnForwardEvent(){
                this.$router.push(this.util.urlPrefix+'/forward/info?course_id='+this.params.poster.course_poster_id+'&url='+this.this_url+'&token='+this.util.token);
            },
            //是否开启报名
            bindIsCollectInfo(){
                var _self=this;
                this.util.server.mini_apply.get_ddrps({
                    data:{
                        course_id:this.course_id
                    },
                    callback: res => {
                        if(!!res.data.ddrps_id){
                            this.is_collect_info=true;
                            this.ddrps_id=res.data.ddrps_id;
                        }
                    }
                })
            },
            //跳转报名地址
            bindGotoCollectInfoIndex(){
                this.$router.push(this.util.urlPrefix+'/collect_info/index?ddrps_id='+this.ddrps_id+'&token='+this.util.token)
            },
            //互动-作业
            bindInteractionEvent(){
                if(!this.works_list.work_book_id && this.works_list.work_book_id == '' ){
                    return this.util.showToast({
                        message:'暂无作业'
                    })
                }

                this.$router.push(this.util.urlPrefix+'/course_task/index?work_book_id='+this.works_list.work_book_id+'&token='+this.util.token);
            },
            bindCurriculumDetail(){
                var _self=this;
                this.util.server.mini_course.set_detail({
                    data: {
                        course_id: this.course_id
                    },
                    callback: (res => {
                        var data= res.data;

                        document.title=data.name
                        _self.$(document).attr('title',data.name)

                        this.util.tansPics(data, 'cover', {
                            default_img: '',
                            style: 'w375'
                        });

                        if (data.content) {
                            data.content = data.content.replace(/<img/gi,'<img style="max-width:100%;height:auto"');
                        }

                        var posterShow=false;
                        if(Object.keys(data.poster).length > 0){
                            posterShow = true;
                        }

                        this.params = data;
                        this.posterShow = posterShow;
                        this.is_body_show=true;
                        // 如果没有章节，直接分享的时候处理方案
                        _self.bindWxShare();

                        if(this.params.is_own == 0  ){
                            this.type = 'XiangQing';
                            this.bindSwitch(this.type);
                        }
                    })
                });
            },
            bindMiniV1Course(page){
                var _self=this;
                if(!page){
                    var pageNo = this.page;
                    pageNo +=1;

                    this.page = pageNo;

                }else{

                    this.page = page;

                }

                this.util.server.mini_v2_course.set_catalog({
                    data: {
                        course_id: this.course_id,
                        sections_id: this.currents,
                    },
                    callback: (res => {
                        var data= res.data;
                        //赋值总数量
                        if(data.total){
                            this.total = data.total;
                        }

                        if(data.items.length>0) {

                            //找出是否有上次播放记录
                            for (var i = 0; i < data.items.length; i++) {
                                //计算播放百分比
                                var time_percentage = Math.floor(data.items[i].last_play_position / data.items[i].mates_duration * 100);
                                data.items[i].time_percentage = time_percentage;

                                if (data.items[i].curr_section && this.currents == '') {
                                    this.currents=data.items[i].sections_id;
                                    this.current=data.items[i].sections_id;
                                }
                            }

                            if(this.currents != ''){
                                //计算当前元素的滑动位置
                                var subscript=0;
                                for (var i= 0;i<data.items.length;i++){
                                    if(this.currents == data.items[i].sections_id){
                                        subscript = i;
                                        break;
                                    }
                                }
                                var subscripts =  160 * subscript;
                                // this.page = data.current_page;
                                // this.page_zuo = data.current_page;
                                // this.page_you = data.current_page;
                                this.scrollXS = subscripts;
                            }

                            var scrollLeft = this.scrollXS;//左滑动定位
                            if (this.currents == '') {
                                scrollLeft = 160 * data.items.length;//元素宽度
                            }

                            // if(parseInt(this.current_page)>parseInt(data.current_page)){
                            //     this.curriculum_list = this.curriculum_list.concat(data.items);
                            // }else{
                            //     if(this.currents==''){
                            //         scrollLeft +=1580;//元素宽度
                            //     }
                            //     this.curriculum_list=data.items.concat(this.curriculum_list);
                            // }

                            this.scrollX = scrollLeft;
                            this.curriculum_list=data.items

                            if(_self.current == '' && data.items.length>0){
                                // TODO 线上课 默认从第一个开始
                                var myindex = 0
                                this.current = data.items[myindex].sections_id;

                                this.switchNav(myindex);
                                this.scrollIndex=myindex;
                            }else{
                                this.switchNav(subscript);
                                this.scrollIndex=subscript;
                            }

                            this.current_page= data.current_page

                            this.currents = '';

                            if(!this.perform_once){
                                _self.bindCurriculumAudioDetail();
                                _self.bindCurriculumQuestionTest();
                            }

                            this.perform_once = true;

                            if(this.work_busy_id != ''){
                                this.type = 'HuDong';
                            }
                        }else{
                           this.is_media_play=false;
                           this.isPageScrollTop=true;
                           this.is_scroll=false;

                            if(!this.params.have_description){
                                this.type = 'XiangQing';
                            }

                            if(this.work_busy_id != ''){
                                this.type = 'HuDong';
                            }
                        }

                        this.bindSwitch(this.type);
                    })
                });
            },
            switchNav(e){
                let that = this;

                if(typeof e == 'number'){
                    var cur = e;
                    var onheadactive = this.scrollX;
                }else{
                    var cur  = e.currentTarget.dataset.current;
                    var onheadactive = e.currentTarget.offsetLeft; // 元素距离左侧的位置
                }
                let winweight = window.innerWidth; // 设备宽度
                let domWidth = 140; // 元素的宽度
                let distance = onheadactive - winweight / 2 + domWidth / 2;
                let sliedeLeft = onheadactive;

                if (sliedeLeft <= 0) {
                    sliedeLeft = 0;
                }

                //tab选项居中
                setTimeout(function () {
                    document.querySelector('#scroll').scrollLeft =distance;
                },500)
                this.currentTab=cur;


            },
            bindCurriculumAudioDetail(){
                if(this.curriculum_list.length==0){
                    return
                }
                var _self=this;

                this.bindBoFangShiChang();
                clearInterval(duration_time_Interval);

                this.util.server.mini_course.sections_detail({
                    data: {
                        sections_id: this.current
                    },
                    callback: (res => {
                        this.setTimeFlag = 1;
                        var data= res.data;
                        //data.content = data.content.replace(/<img/gi,'<img style="max-width:100%;height:auto"');
                        _self.curriculum_audio_detail=data;

                        _self.bindWxShare();

                        // this.$nextTick(function () {
                        //     this.regionShow(this.current);
                        // })
                        //
                        // if(!this.perform_once){
                        //     document.querySelector('#scroll').scrollLeft = this.scrollX;
                        // }

                        // TODO 视频资源没有加载完成

                        _self.curriculum_list[_self.scrollIndex].last_play_position = data.last_play_position
                        switch (_self.curriculum_audio_detail.mates_type) {
                            case 1:
                                if(_self.params.is_own != 0){

                                    _self.$nextTick(function () {
                                        let audioPlayer = document.getElementById('audioPlayer');
                                        console.log("audioPlayer",audioPlayer)
                                        //audioPlayer.currentTime = _self.curriculum_list[_self.scrollIndex].last_play_position
                                        //audio.fastSeek(_self.curriculum_list[_self.scrollIndex].last_play_position);
                                        console.log('env.iOS',env.iOS)
                                        console.log('env.wxpc',env.wechatdevtools)
                                        if(env.iOS && !env.wechatdevtools){
                                          audioPlayer.addEventListener("canplay",function() {
                                            audioPlayer.currentTime = _self.curriculum_list[_self.scrollIndex].last_play_position
                                          });
                                        }else{
                                          audioPlayer.currentTime = _self.curriculum_list[_self.scrollIndex].last_play_position
                                        }
                                     })

                                     
                                    //let audioPlayer = document.getElementById('audioPlayer');
                                    //console.log("audioPlayer",audioPlayer)
                                    //audioPlayer.currentTime = 100
                                    
                                    _self.setAudioInterval();
                                    //播放量
                                    this.bindBoFangLiang();
                                    //播放时长
                                    this.setIntervalDurationTime(true);

                                }

                                if(_self.params.is_own == 0){
                                    setTimeout(function () {
                                        document.getElementById('audioPlayer').pause();
                                    },1000);
                                }
                                break;
                            case 2:
                                _self.currentTime = _self.curriculum_list[_self.scrollIndex].last_play_position
                                this.playerOptions.sources[0].src=_self.curriculum_audio_detail.mates_path;
                                this.playerOptions.poster = this.params.cover;
                                setTimeout(function () {
                                    //document.querySelector('video').currentTime=_self.curriculum_list[_self.scrollIndex].last_play_position;
                                    if(_self.params.is_own == 0){
                                        _self.playerOptions.controls=false;
                                        document.querySelector('video').pause();
                                    }
                                },1000);
                                break;
                        }

                    })
                });
            },
            //切换type
            bindType(e){
                var type=e.currentTarget.dataset.type;
                this.bindSwitch(type);
            },
            bindSwitch(type){
                this.type = type;
                switch (type) {
                    case 'HuDong':
                        if(!this.works_list.cnt){
                            //this.getWorksEvent();
                        }
                        break;
                    case 'ZhangJieYuGao':
                        
                        this.getTaolunSummary()
                        break;
                    case 'KaoShi':
                        if(!this.testing_params.name){
                            this.getCourseTesting();
                        }
                        break;
                }
            },
            //获取考试信息
            getCourseTesting(){
                var _self = this;
                this.util.server.mini_testing.get_course_testing({
                    data:{
                        course_id:this.course_id
                    },
                    callback:(res=>{
                        this.util.tansPics(res.data, 'cover_url', {
                            default_img: '',
                            style: 'w375'
                        });
                        this.testing_params = res.data;
                        console.log(this.testing_params)
                    })
                })
            },
            //考试页面
            bindGotoTesting(){
                if(this.testing_params.user_status == 0 || this.testing_params.user_status == 1){
                    this.$router.push(this.util.urlPrefix+'/testing/index?test_id='+this.testing_params.test_id+'&token='+this.util.token)
                }else if(this.testing_params.user_status == 3 || this.testing_params.user_status == 2){
                    this.$router.push(this.util.urlPrefix+'/testing/answered?test_id='+this.testing_params.test_id+'&token='+this.util.token)
                }
            },
            //获取课程作业
            getWorksEvent(){
                var _self = this;
                this.util.server.mini_work.get_works({
                    data:{
                        course_id:this.course_id
                    },
                    callback:(res=>{
                        this.works_list = res.data;
                    })
                })
            },
            //播放时长
            setIntervalDurationTime(reset){
                var _self=this;

                //清0
                if(reset){
                    _self.duration_time=0;
                }

                duration_time_Interval=setInterval(function () {
                    //console.log("时间增加",_self.duration_time)
                    _self.duration_time +=1;

                },1000);
            },
            bindBoFangShiChang(){
                if(!this.curriculum_audio_detail){
                    return
                }
                if(this.duration_time==0){//如果播放时长为零，不进行上报
                  // 比如处于暂停状态，然后进行切换视频
                  console.warn("播放时长为零,不进行上报")
                   return
                }
                
                //播放时长
                var _self=this;
                this.util.server.event.event({
                    data: {
                        message:{
                            course_id:this.course_id,
                            duration:this.duration_time,
                            // play_position:this.audioCurrentTime,
                            play_position: _self.util.timeToSec(this.audioCurrentTime),
                            train_id:this.util.train_id,
                            p_course_id: _self.p_id,
                            uid:this.util.getUserId.get(),
                            sections_id:this.curriculum_audio_detail.sections_id,
                            index:this.current
                        },
                        code:10012,
                    },
                    callback: (res => {})
                });
            },
            bindBoFangLiang(){
                //播放量+1
                this.util.server.event.event({
                    data: {
                        message:{
                            course_id:this.course_id,
                            source:this.source,
                            sections_id:this.curriculum_audio_detail.sections_id,
                            index:this.current
                        },
                        code:10011,
                    },
                    callback: (res => {})
                });
            },
            /****************音频******************/
            //设置定时检测
            setAudioInterval(){
                audioInterval = setInterval(()=>{

                    this.getAudioTime();
                    let audioPlayer = document.getElementById('audioPlayer');
                    if(audioPlayer.ended){
                        //播放完成上传播放时间及位置
                        this.bindBoFangShiChang()
                        //播放结束后重置数据
                        clearInterval(audioInterval);
                        clearInterval(duration_time_Interval);
                        //this.audioTime=0;
                        //audioPlayer.currentTime = 0;
                        //this.audioCurrentTime='00:00';
                        this.isPlay=false;

                        //播放时长 , 不在启动定时器
                        //this.setIntervalDurationTime(true); 
                        this.duration_time=0;

                    }
                    if(audioPlayer.paused){
                        this.isPlay=false
                    }else{
                        if(!this.is_continue){
                            document.getElementById('audioPlayer').pause();
                            return;
                        }
                        this.isPlay=true
                    }
                },500)
            },
            //播放
            playAudio(){
                if(this.params.is_own == 0){
                    document.getElementById('audioPlayer').pause()
                    return this.util.showToast({
                        message:'请先'+(this.params.sell_mode == 1?'购买':'领取')+'课程'
                    });
                }
                this.is_media_play=true;
                //重设定时器
                clearInterval(audioInterval);
                this.getAudioTime();
                this.setAudioInterval();
                this.is_continue=true;

                //播放量
                this.bindBoFangLiang();
                //播放时长
                this.setIntervalDurationTime(true);
                document.getElementById('audioPlayer').play();
                this.isPlay=true;
            },
            //暂停
            pauseAudio(){
                this.is_media_play=false;
                if(this.is_mask){
                    return ;
                }
                document.getElementById('audioPlayer').pause();
                this.isPlay=false;

                //重置定时器
                clearInterval(duration_time_Interval);
                this.bindBoFangShiChang();

                //重置播放时长为零
                this.duration_time=0;
            },
            //获取播放时间
            getAudioTime(){
                let audioPlayer = document.getElementById('audioPlayer');
                // console.log("播放总时间--"+realFormatSecond(audioPlayer.duration));
                // console.log("已播放秒数--"+realFormatSecond(audioPlayer.currentTime));
                //展示用
                this.audioAllTime = this.util.getTime(audioPlayer.duration);
                this.audioAllDuration = audioPlayer.duration;
                this.audioCurrentTime = this.util.getTime(audioPlayer.currentTime);
                //计算当前进度百分比
                this.audioTime = (audioPlayer.currentTime*100/audioPlayer.duration).toFixed(3)*1;
                // console.log("百分比--"+this.audioTime)

                //计算播放百分比
                var time_percentage = Math.floor(audioPlayer.currentTime / this.curriculum_list[this.scrollIndex].mates_duration * 100);
                this.curriculum_list[this.scrollIndex].time_percentage=time_percentage;

                if(!this.is_question_load){
                    return;
                }
                //是否显示题目
                var current_time= this.util.getTime(audioPlayer.currentTime,'h:m:s');
                //如果设置了这个时间段有题目，并且没有答过、关闭过。
                if(this.question_list[current_time] && !this.question_list[current_time][0].isAnswer && !this.question_test_time_list[current_time]){

                    this.pauseAudio();
                    this.is_mask=true;
                    this.question_test_time = current_time;
                }
            },
            //滑动进度条
            sliderChange(value){
                if(this.params.is_own == 0){
                    return document.getElementById('audioPlayer').pause();
                }
                // 设置播放时间
                let audioPlayer = document.getElementById('audioPlayer');
                this.audioCurrentTime =  this.util.getTime(this.audioAllDuration*value/100);
                audioPlayer.currentTime = parseInt(this.audioAllDuration*value/100)
            },
            //设置倍速播放
            changeMultiple(){
                if(this.params.is_own == 0){
                    return false;
                }
                if(this.multipleIndex<4){
                    this.multipleIndex++
                }else{
                    this.multipleIndex=0
                }
                let audioPlayer = document.getElementById('audioPlayer');
                audioPlayer.playbackRate = this.multipleArray[this.multipleIndex]
            },
            /******************视频*************************/
            onPlayerPlay(e){
                if(this.params.is_own == 0){
                    document.querySelector('video').pause()
                    return this.util.showToast({
                        message:'请先'+(this.params.sell_mode == 1?'购买':'领取')+'课程'
                    });
                }
                this.is_media_play=true;
                //播放量
                this.bindBoFangLiang();
                //播放时长
                this.setIntervalDurationTime(true);
            },
            onPlayerPause(e){
                console.log("暂停")
                this.is_media_play=false;
                //重置定时器
                clearInterval(duration_time_Interval);
                this.bindBoFangShiChang();
            },
            onPlayerTimeUpdate(e){
                if(this.params.is_own == 0){
                    return document.querySelector('video').pause();
                }
                var _self=this;
                if(!this.is_question_load){
                    return;
                }

                let videoPlayer =  document.querySelector('video');
                this.audioCurrentTime = this.util.getTime(videoPlayer.currentTime);

                //计算播放百分比
                var time_percentage = Math.floor(videoPlayer.currentTime / _self.curriculum_list[_self.scrollIndex].mates_duration * 100);
                this.curriculum_list[_self.scrollIndex].time_percentage=time_percentage;
                this.$forceUpdate();

                //找出托动后最近的一个题目，。如果没有答过则显示
                var test_time = '';
                for (var i in this.question_list){
                    if(i == 'is_force') continue;

                    if(videoPlayer.currentTime >= this.util.timeToSec(i)){
                        test_time = i;
                    }
                }

                //如果设置了这个时间段有题目，并且没有答过、关闭过。
                if(this.question_list[test_time] && !this.question_list[test_time][0].isAnswer && !this.question_test_time_list[test_time]) {

                    //如果是全屏则退出全屏
                    // if (this.videoFullScreen) {
                    //     video.exitFullScreen();
                    //     this.setData({
                    //         videoFullScreenMonitor: true
                    //     })
                    // } else {
                    //     this.setData({
                    //         videoFullScreenMonitor: false
                    //     })
                    // }

                    this.is_mask=true;
                    this.question_test_time = test_time;
                    videoPlayer.pause();
                }

                if(this.setTimeFlag == 1){
                    //myPlayer[0].currentTime = lastCurrentTime;
                    e.currentTime(_self.currentTime)
                    this.setTimeFlag = 2;
                }

            },
            /***************************************随堂测验区域代码 start***********************************************/
            //题目
            bindCurriculumQuestionTest(){
                this.util.server.mini_question.test({
                    data:{
                        course_id:this.course_id,
                        sections_id:this.current
                    },
                    callback: (res => {
                        var data = res.data;

                        this.question_list=data;
                        this.question_test_time_list={};
                        this.question_test_time='';
                        this.is_question_load=true;
                    })
                })
            },
            //单选题答案选择
            bindQuestionSingleButton(e){
                if(this.answer_list.length >0 ){
                    return false;
                }
                var idx = this.question_idx;

                var question_options_id = e.currentTarget.dataset.id;
                var question_rule_id = this.question_list[this.question_test_time][idx].question_rule_id;
                var answer =question_options_id;

                var set = {
                    question_rule_id:question_rule_id,
                    answer:answer,
                    question_options_id:question_options_id
                };

                this.$set(this.question_set_list,idx,set);
                this.$forceUpdate();
            },
            //多选题答案选择
            bindQuestionManyButton(e){
                if(this.answer_list.length >0 ){
                    return false;
                }
                var idx = this.question_idx;
                var question_options_id = e.currentTarget.dataset.id;
                var question_rule_id = this.question_list[this.question_test_time][idx].question_rule_id;
                var answer =[question_options_id];

                if(this.question_set_list[idx] && this.question_set_list[idx].answer){
                    answer = this.question_set_list[idx].answer;

                    if(answer.indexOf(question_options_id) > -1){
                        answer.splice(answer.indexOf(question_options_id),1);
                    }else{
                        answer.push(question_options_id);
                    }
                }

                var set = {
                    question_rule_id:question_rule_id,
                    answer:answer,
                    question_options_id:question_options_id
                };

                this.$set(this.question_set_list,idx,set);
                this.$forceUpdate();

                if(answer.length == 0){
                    this.question_set_list.splice(idx,1);
                }
            },
            //判断题答案选择
            bindQuestionJudgeButton(e){
                if(this.answer_list.length >0 ){
                    return false;
                }
                var idx = this.question_idx;

                var question_options_id = e.currentTarget.dataset.id;
                var question_rule_id = this.question_list[this.question_test_time][idx].question_rule_id;
                var answer =e.currentTarget.dataset.is_true;

                var set = {
                    question_rule_id:question_rule_id,
                    answer:answer,
                    question_options_id:question_options_id
                };

                this.$set(this.question_set_list,idx,set);
                this.$forceUpdate();
            },
            //填空题答案输入
            bindQuestionBlanksButton(e){

                var idx = this.question_idx;
                var index = e.currentTarget.dataset.index;

                if(e.target.value == ''){
                    this.question_set_list[idx].answer.splice(index,1);
                    return;
                }

                var question_options_id = e.currentTarget.dataset.id;
                var question_rule_id = this.question_list[this.question_test_time][idx].question_rule_id;
                var answer =[];
                if(this.question_set_list[idx] && this.question_set_list[idx].answer){
                    answer = this.question_set_list[idx].answer;
                }
                answer[index]=e.target.value;

                var set = {
                    question_rule_id:question_rule_id,
                    answer:answer,
                    question_options_id:question_options_id
                };

                this.$set(this.question_set_list,idx,set);
                this.$forceUpdate();
            },
            //问答题答案输入
            bindQuestionQAInputButton:function(e){
                var idx = this.question_idx;

                if(e.target.value == ''){
                    this.question_set_list.splice(idx,1);
                    return;
                }

                var question_options_id = e.currentTarget.dataset.id;
                var question_rule_id = this.question_list[this.question_test_time][idx].question_rule_id;
                var answer =e.target.value;

                var set = {
                    question_rule_id:question_rule_id,
                    answer:answer,
                    question_options_id:question_options_id
                };

                this.$set(this.question_set_list,idx,set);
                this.$forceUpdate();
            },
            //上一题
            bindUpperLower:function(){
                var idx = this.question_idx;
                idx -=1;

                this.question_idx=idx;
            },
            //下一题
            bindQuestionLower:function(){

                var idx = this.question_idx;

                if(!this.question_set_list[idx]){
                    return this.util.showToast({
                        message:'答案不能为空'
                    })
                }

                //填空题校验
                if(this.question_list[this.question_test_time][idx].question_type == 4){
                    for (var i =0;i<this.question_list[this.question_test_time][idx].question_options.length;i++){
                        if(!this.question_set_list[idx].answer[i]){
                            return this.util.showToast({
                                message:'第'+(i+1)+'空答案不能为空'
                            })
                        }
                    }
                }

                idx +=1;

                this.question_idx=idx;
            },
            //提交
            bindQuestionSave:function(){
                var _self=this;
                var idx = this.question_idx;

                if(!this.question_set_list[idx]){
                    return this.util.showToast({
                        message:'答案不能为空'
                    })
                }

                //填空题校验
                if(this.question_list[this.question_test_time][idx].question_type == 4){
                    for (var i =0;i<this.question_list[this.question_test_time][idx].question_options.length;i++){
                        if(!this.question_set_list[idx].answer[i]){
                            return this.util.showToast({
                                message:'第'+(i+1)+'空答案不能为空'
                            })
                        }
                    }
                }

                this.util.server.mini_question.answer({
                    data:{
                        answers:this.question_set_list
                    },
                    callback:(res=>{
                        var data = res.data;

                        if(data.length > 0){
                            for (var i=0;i<data.length;i++){
                                var item = data[i];
                                var result_answer = false;
                                if(item.trues instanceof Array){
                                    var trues = item.trues.join(',');
                                    var answer = item.answer;
                                    if(item.answer instanceof Array){
                                        answer = item.answer.join(',');
                                    }

                                    if(answer.indexOf(trues) > -1){
                                        result_answer = true;
                                    }
                                }else{
                                    if(item.trues*1 == item.answer*1){
                                        result_answer = true;
                                    }
                                }

                                data[i].result_answer = result_answer;
                            }
                        }

                        _self.answer_list = res.data;
                        _self.question_idx = 0;
                        // this.is_mask=false;
                        // this.question_test_time_list[this.question_test_time]=true;
                        // this.question_idx=0;
                        // this.question_set_list=[];
                        //
                        // if(_self.curriculum_audio_detail.mates_type == 1){
                        //     _self.playAudio();
                        // }else if(this.curriculum_audio_detail.mates_type == 2){
                        //
                        //     // //如果有全屏的记录则进入全屏后在播放
                        //     // if(this.data.videoFullScreenMonitor){
                        //     //     video.requestFullScreen();
                        //     // }
                        //     //
                        //     document.querySelector('video').play();
                        // }
                    })
                })
            },
            //关闭答题
            bindQuestionCloseMask:function(){
                this.is_mask=false;
                this.question_test_time_list[this.question_test_time] = true;
                this.question_idx=0;
                this.question_set_list=[];
                this.answer_list=[];

                if(this.curriculum_audio_detail.mates_type == 1){
                    this.playAudio();
                }else if(this.curriculum_audio_detail.mates_type == 2){

                    //如果有全屏的记录则进入全屏后在播放
                    // if(this.data.videoFullScreenMonitor){
                    //     video.requestFullScreen();
                    // }
                    //
                    document.querySelector('video').play();
                }
            },

            /**********************作业区域代码 start************************/
            bindmyworkparams(e){
                this.my_work_params = e.params
            },
            bindworkchatparams(e){
                this.work_chat_params.chatBottom = e.params.chatBottom;
                this.work_chat_params.isChat = e.params.isChat;
                this.work_chat_params.MsgPlaceholder = e.params.MsgPlaceholder;
            },
            /**********************作业区域代码 end************************/
            bodyScroll(e){
                console.log(e)
            },

            /**********************讨论区代码 start************************/
            bandTaolunFocus(){
                this.taolun_text_show = true
            },
            bandTaolunClose(){
                this.taolun_text_show = false
            },
            bindTaolunPubTextOpen(){//弹窗打开后
                console.log('打开后聚焦bindTaolunPubTextOpen')
                //this.$refs.taolun_content.focus()
            },
            bindTaolunDisBtn(){
                this.taolun_discuss_show = true
            },
            bindTaolunDisOpen(){//弹窗打开后
                this.$refs.courseDiscuss.eventInit()
            },
            bindTaolunPublish(){
                let _self = this
                if(this.taolun_sub.content==''){
                    return this.util.showToast({
                        message:'输入些点评内容吧'
                    })
                }

                //如果存在图片进行预处理
                if(this.taolun_filelist.length>0){
                    this.taolun_sub.res_type = 1
                    _self.taolun_sub.res_datas = []
                    this.taolun_filelist.forEach(function(item, index){
                        console.log("11111")
                        _self.taolun_sub.res_datas.push(item.url);
                    });
                }
                console.log('this.taolun_sub', this.taolun_sub)
                //return false;
                this.taolun_sub.course_id = this.course_id
                this.util.server.mini_discus.pub_reply({
                    data:this.taolun_sub,
                    callback:(res=>{
                        if(res.code==1){
                            let data = res.data;
                            console.log(data)
                            this.taolun_text_show = false
                            this.taolun_discuss_show = true

                            // 成功后清空默认值
                            this.taolun_sub = {
                                            course_id: "",
                                            content: "",
                                            res_type: "",
                                            res_datas: "",
                                            privacy_status: 1
                                        }
                            //发布成功设置为空
                            this.taolun_filelist = [];

                            //发布成功后 评论计数加1
                            this.taolun_summary.reply_count ++

                        }else{
                            _self.util.showToast({
                                message:'网络异常,请重新尝试'
                            })
                        }

                    })
                })


            },
            // 讨论列表关闭按钮
            bindTaolunDisClose(){
                this.taolun_discuss_show = false
            },
            // 讨论点赞
            bindTaolunCourseFavor(){
                var _self = this;
                this.util.server.mini_discus.sub_course_favor({
                    data:{
                        course_id:this.course_id,
                        favor_type:this.taolun_summary.is_favor_course?0:1,
                    },
                    callback:(res=>{
                        if(res.code==1){
                            this.taolun_summary.is_favor_course = this.taolun_summary.is_favor_course?0:1
                            if(this.taolun_summary.is_favor_course){
                                this.taolun_summary.favor_count++
                            }else{
                                this.taolun_summary.favor_count--
                            }
                            _self.util.showToast({
                                message:'操作成功'
                            })
                        }else{
                            _self.util.showToast({
                                message:'网络异常,请重新尝试'
                            })
                        }
                    })
                })
            },
            // 讨论概要
            getTaolunSummary(){
                var _self = this;
                this.util.server.mini_discus.course_reply_summary({
                    data:{
                        course_id:this.course_id
                    },
                    callback:(res=>{
                        this.taolun_summary = res.data
                    })
                })
            },
            bindImageClick(){
                this.$refs.taolun_upload.chooseFile()
            },
            bindPrivacyClick(){
                this.taolun_sub.privacy_status = this.taolun_sub.privacy_status==1?3:1
            },
            afterRead(e){
                var _self = this;

                e.status = 'uploading';
                e.message = '上传中...';
                if(e instanceof Array){
                    e.forEach((value,index,array) => {

                        this.util.upfile({
                            file: value.file,
                            data: {},
                            callback: res => {
                                value.status = 'done'
                                value.message = '上传成功'
                                value.url = res.data.domain_url

                            }
                        });
                    })
                }else{
                    this.util.upfile({
                        file: e.file,
                        data: {},
                        callback: res => {
                            e.status = 'done'
                            e.url = res.data.domain_url
                            e.message = '上传成功'
                        }
                    });
                }
            }
            /**********************讨论区代码 end************************/
        }
    }
</script>

<style scoped>
    div{
        color: #3a3a3a;
    }
    .swiper-img{
        height: 100%;
        width: 100%;
    }
    .pdf-content .pdf-text{
        position:absolute;
        bottom:0;
        right:0;
        color:#fff;
        padding:2px 10px;
        background-color:#327CE9;
        font-size:12px;
    }

    .wares-li{
        margin-bottom:10px;
        border-bottom:1px solid #eee;
    }
    .wares-li .wares-top{
        position:relative;
    }
    .wares-top .wares-name{
        display:-webkit-box;
        padding-right:55px;
        -webkit-box-orient:vertical;
        -webkit-line-clamp:2;
        overflow:hidden;
        text-overflow:ellipsis;
        font-weight:bold;
    }
    .wares-top .wares-time{
        position:absolute;
        right:0;
        top:0;
        font-size:12px;
        color:#aaa;
    }
    .wares-li .wares-txt{
        margin:10px 0;
        font-size:12px;
    }
    .wares-img{
        margin-top:10px;
        padding:10px 0;
        border-top:1px dashed #eee;
        text-align:center;
        font-weight:bold;
    }
    .make-an-appointment{
        position: fixed;
        bottom: 50px;
        width: 100%;
        border: 1px solid #ccc;
        background-color: #fff;
        display: flex;
        left: 0;
        right: 0;
        margin: 0 auto;
        max-width: 480px;
        padding-bottom: env(safe-area-inset-bottom);
    }
    .share{
        text-align: center;
        display: inline-block;
        border-right: 1px solid #ccc;
        padding: 0 15px;
        line-height: 39px;
        background-color: #fff;
        border-radius:0;
    }
    .share::after{
        content: '';
        width: 0;
        height: 0;
    }
    .trial-class{
        text-align: center;
        display: inline-block;
        border-right: 1px solid #ccc;
        padding: 10px 20px;
    }
    .make-an-appointment-text{
        display: inline-block;
        text-align: center;
        background-color: #FF6600;
        color: #fff;
        border-right: 1px solid #ccc;
        padding: 10px;
        flex: 1;
    }
    .input-text{
        width: 100%;
        background-color: transparent;
        border: 0;
    }
    .input-textarea{
        width: 100%;
        height: 50px;
        background-color: transparent;
        border: 0;
        resize: none;
    }
    .cover >>> .van-slider__button{
        width: 12px;
        height: 12px;
    }
    .cover{
        width: 100%;
        margin: 0 auto;
        text-align: center;
        position: relative;
        font-size: 0;
    }
    .position-a{
        position: absolute;
        bottom: 0;
        width: 100%;
        background: rgba(0,0,0,0.3);
        padding: 10px;
        box-sizing: border-box;
    }
    .position-a .tools{
        background-color: transparent;
        color: #fff;
    }
    .position-a .tools .iconfont{
        font-size: 22px;
    }
    .cover-img{
        height: 100%;
        width: 100%;
    }
    .course-name{
        font-size: 18px;
        color: #000;
        text-align: center;
        padding: 0 10px;
        margin-top: 20px;
    }
    .course-time{
        text-align: center;
        font-size: 12px;
        color: #aaa;
        margin-left: 10px;
        display: inline-block;
        vertical-align: middle;
        padding: 12px 0;
    }
    .table{
        display: table;
        width: 100%;
        overflow: hidden;
        border-bottom: 1px solid #eee;
    }
    .table.fixed{
        position: fixed;
        top:0;
        z-index:1;
        margin-top: 0;
    }
    .table .tab-li{
        background-color: #fff;
        display: table-cell;
        font-size: 16px;
        min-width: 74px;
        padding: 0 5px;
        height: 40px;
        text-align: center;
        vertical-align: middle;
        position: relative;
    }
    .table .tab-li.curr:after {
        position: absolute;
        content: "";
        bottom: 0;
        width: 42px;
        height: 3px;
        background: rgba(52, 155, 248, 1);
        opacity: 1;
        border-radius: 4px;
        left: 50%;
        margin-left: -21px;
    }
    .table-content{
        width: 100%;
        height: 100%;
        background-color: #fff;
    }
    .table-content-xiangqing{
        width: 100%;
        height: 100%;
        position: relative;
        padding: 20px;
        box-sizing: border-box;
        overflow-y: auto;
        overflow-x: hidden;
    }
    .time{
        color: #fff;
        text-align: center;
        flex: 1;
        font-size: 10px;
        padding-right: 10px;
    }
    .line_p {
        position: relative;
        margin: 0 5px;
        flex: 3;
        padding-left: 15px;
    }
    .line{
        height: 1px;
        background: #DDDDDD;
        position: absolute;
        top: 50%;
        width: 100%;
    }
    .line2{
        background: #999999;
    }
    .dian{
        width:10px;
        height:10px;
        background:#327CE9;
        border-radius:50%;
        position: absolute;
        top: 50%;
        margin-top: -5px;
    }
    .ml10{
        margin-left: 10px;
    }
    .tools img{
        width: 22px;
        height: 22px;
        vertical-align: middle;
    }
    .tools .cell__bd{
        text-align: center
    }
    .table-content-MuLv{
        height: 100%;
        width: 100%;
    }
    .pub-list{
        overflow:hidden;
        width: 100%;
    }
    .pub-list .pub-item{
        position: relative;
        padding: 20px;
        float: left;
        width: 100%;
        border-bottom: 1px solid #eee;
        box-sizing: border-box;
        -o-box-sizing: border-box;
        -ms-box-sizing: border-box;
        -moz-box-sizing: border-box;
        -webkit-box-sizing: border-box;
    }
    .pub-item .pub-item-type{
        float: left;
        padding: 2px 5px;
        border: 1px solid #ddd;
        font-size: 12px;
        vertical-align: top;
    }
    .pub-item .item-title{
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        vertical-align: middle;
        font-size: 16px;
        padding-left: 20px;
    }
    .pub-item .item-title.alive{
        color: #24C222;
    }
    .pub-no{
        text-align: center;
        font-size: 16px;
        margin: 20px 0;
    }
    .bs .cell_t{
        font-size: 17px;
        color: #00B5C9;
    }
    .sc .cell_t{
        font-size: 17px;
        color: #FEB400;
    }
    .zf .cell_t{
        font-size: 17px;
        color: #327CE9;
    }
    .cell_b{
        font-size:12px;
        color: #999999;
    }
    .tabs{
        border-top: 1px solid #eee;
        border-bottom: 1px solid #eee;
        padding: 10px 0;
    }
    .hide{
        display: none;
    }
    .event-info{
        display: inline-block;
        height: 100%;
        width: 40px;
        text-align: center;
        line-height: 40px;
    }
    .resources{
        background-color: #fff;
    }
    .resources-event{
        float: right;
        height: 40px;
    }
    .video{
        width: 100%;
    }
    .video-content{
        font-size: 0;
    }
    ::-webkit-scrollbar {
        width: 0;
        height: 0;
        color: transparent;
    }
    .collect-info{
        position: fixed;
        bottom: 100px;
        right: 0;
        /*padding: 10px;*/
        /*background-color: #fff;*/
        /*border: 1px solid #eee;*/
        /*border-radius: 10px 0 0 10px;*/
        /*font-weight: bold;*/
        /*box-shadow: 1px 1px 2px #ccc;*/
    }
    .mask{
        position: fixed;
        top: 0;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,.5);
        overflow-y: auto;
        z-index: 1;
    }
    .topic{
        position: absolute;
        top: 50%;
        padding: 10px;
        width: 300px;
        box-sizing: border-box;
        background-color: #fff;
        overflow: hidden;
        transform: translate(-50%,-50%);
        left: 50%;
    }
    .topic-frameli{
        text-align: center;
        font-size: 14px;
        margin: 10px;
        margin-bottom: 20px;
    }
    .topic-frameli span{
        color: #fbb561;
        font-size: 14px;
    }
    .entrance-bottom-frame {
        transition: all 0.5s;
        margin-top: 10px;
    }
    .entrance-bottom-frame-line {
        transition: all 0.5s;
    }
    .entrance-bottom-frame-line-title{
        font-size: 12px;
        margin-bottom: 20px;
    }
    .entrance-bottom-frame-line-button{
        font-size: 12px;
        padding: 10px 15px;
        background-color: #f7f7f7;
        border-radius: 20px;
        margin-bottom: 20px;
    }
    .entrance-bottom-frame-line-button.sel{
        color: #ffffff;
        background: #f86d07;
    }
    .topic-btn{
        display: flex;
        text-align: center;
    }
    .topic-btn .btn{
        flex: 1;
        padding: 5px 0;
        margin: 0 20px;
        color: #fff;
        border-radius: 10px;
        font-size: 12px;
    }
    .topic-btn .upper{
        background-color: #3282b8;
    }
    .topic-btn .save{
        background-color: #ff5f40;
    }
    .topic-btn .lower{
        background-color: #24a19c;
    }
    .topic-title{
        position: relative;
    }
    .topic-close{
        position: absolute;
        top: -3px;
        right: 0;
        background-color: #f30;
        color: #fff;
        padding: 2px 5px;
        font-size: 12px;
        border-radius: 5px;
    }
    .interaction{
        position: relative;
        border-bottom:1px dashed #ccc;
        padding-bottom: 5px;
    }
    .interaction-icon{
        vertical-align: top;
        display: inline-block;
    }
    .interaction-icon .iconjiaoyu{
        font-size: 24px;
    }
    .interaction-content{
        display: inline-block;
        padding-left: 20px;
    }
    .interaction-content .inter-txt{
        color: #aaa;
        padding-top: 5px;
    }
    .home{
        color: #fff;
        position: fixed;
        right: 10px;
        bottom: 10px;
        background-color: #fff;
        background: rgba(255,133,71,1);
        border-radius: 50%;
        text-align: center;
        padding: 6px 10px;
    }
    .home div{
        font-size: 10px;
        color: #fff;
    }
    .music{
        width: 100%;
        background-color: #fff;
    }
    .cover{
        width: 100%;
        margin: 0 auto;
        text-align: center;
        position: relative;
        font-size: 0;
    }
    .position-a{
        position: absolute;
        bottom: 0;
        width: 100%;
        background: rgba(0,0,0,0.3);
        padding: 5px 0;
    }
    .position-a .tools{
        background-color: transparent;
        color: #fff;
    }
    .position-a .tools .iconfont{
        font-size: 22px;
    }
    .cover-img{
        height: 100%;
        width: 100%;
    }
    .course-name{
        font-size: 18px;
        color: #000;
        text-align: center;
        padding: 0 10px;
        margin-top: 20px;
    }
    .course-time{
        text-align: center;
        font-size: 12px;
        color: #aaa;
        margin-left: 10px;
        display: inline-block;
        vertical-align: middle;
        padding: 12px 0;
    }
    .table{
        display: table;
        width: 100%;
        overflow: hidden;
        border-bottom: 1px solid #eee;
    }
    .table.fixed{
        position: fixed;
        top:0;
        z-index:1;
        margin-top: 0;
    }
    .table .tab-li{
        background-color: #fff;
        display: table-cell;
        font-size: 16px;
        min-width: 74px;
        padding: 0 5px;
        height: 40px;
        text-align: center;
        vertical-align: middle;
        position: relative;
    }
    .table .tab-li.curr:after {
        position: absolute;
        content: "";
        bottom: 0;
        width: 62px;
        height: 2px;
        background: rgba(52, 155, 248, 1);
        opacity: 1;
        border-radius: 4px;
        left: 50%;
        margin-left: -31px;
    }
    .table-content{
        width: 100%;
        height: 100%;
        background-color: #fff;
        display: flex;
        flex: 1;
    }
    .table-content-xiangqing{
        width: 100%;
        height:100%;
        position: relative;
        padding: 10px;
        box-sizing: border-box;
        background-color: #ffffff;
    }
    .time{
        color: #fff;
        text-align: center;
        flex: 1;
        font-size: 10px;
        padding-right: 10px;
    }
    .line_p {
        position: relative;
        margin: 0 5px;
        flex: 3;
    }
    .line{
        height: 1px;
        background: #DDDDDD;
        position: absolute;
        top: 50%;
        width: 100%;
    }
    .line2{
        background: #999999;
    }
    .dian{
        width:10px;
        height:10px;
        background:#327CE9;
        border-radius:50%;
        position: absolute;
        top: 50%;
        margin-top: -5px;
    }
    .ml10{
        margin-left: 10px;
    }
    .tools image{
        width: 22px;
        height: 22px;
        vertical-align: middle;
    }
    .tools .cell__bd{
        text-align: center
    }
    .table-content-MuLv{
        height: 100%;
        width: 100%;
    }
    .pub-list{
        overflow:hidden;
        width: 100%;
    }
    .pub-list .pub-item{
        position: relative;
        padding: 20px;
        float: left;
        width: 100%;
        border-bottom: 1px solid #eee;
        box-sizing: border-box;
        -o-box-sizing: border-box;
        -ms-box-sizing: border-box;
        -moz-box-sizing: border-box;
        -webkit-box-sizing: border-box;
    }
    .pub-item .pub-item-type{
        float: left;
        padding: 2px 5px;
        border: 1px solid #ddd;
        font-size: 12px;
        vertical-align: top;
    }
    .pub-item .item-title{
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        vertical-align: middle;
        font-size: 16px;
        padding-left: 20px;
    }
    .pub-item .item-title.alive{
        color: #24C222;
    }
    .pub-no{
        text-align: center;
        font-size: 16px;
        margin: 20px 0;
    }
    .bs .cell_t{
        font-size: 17px;
        color: #00B5C9;
    }
    .sc .cell_t{
        font-size: 17px;
        color: #FEB400;
    }
    .zf .cell_t{
        font-size: 17px;
        color: #327CE9;
    }
    .cell_b{
        font-size:12px;
        color: #999999;
    }
    .tabs{
        border-top: 1px solid #eee;
        border-bottom: 1px solid #eee;
        padding: 10px 0;
    }
    .hide{
        display: none;
    }
    .event-info{
        display: inline-block;
        height: 100%;
        width: 40px;
        text-align: center;
        line-height: 40px;
    }
    .resources{
        background-color: #fff;
    }
    .resources-event{
        float: right;
        height: 40px;
    }
    .video{
        width: 100%;
    }
    .video-content{
        font-size: 0;
    }
    .i-tabs-tab {
        flex:1;
        display:flex;
        width:100%;
        -webkit-box-pack:center;
        justify-content:center;
        -webkit-box-align:center;
        align-items:center;
        -webkit-box-orient:vertical;
        -webkit-box-direction:normal;
        flex-direction:column;
        position:relative
    }
    .i-tabs-tab-bar {
        display:none;
        width:100%;
        height:2px;
        background:0 0;
        position:absolute;
        bottom:0;
        left:0;
        background:#2d8cf0
    }
    .i-tabs-tab-title {
        font-size:14px;
        box-sizing:border-box;
        color:#80848f;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
        white-space: normal;
        height: 40px;
    }
    .i-tabs-tab-title-current {
        color:#2d8cf0
    }
    .i-tabs-tab-scroll {
        display: inline-block;
        width: 140px;
        border: 1px solid #eee;
        margin: 10px;
        height: 80px;
        padding: 5px;
        box-sizing: border-box;
        border-radius: 5px;
        vertical-align: middle;
        overflow: hidden;
    }
    .i-tabs-tab-current {
        background:#fff;
        border: 1px solid #ff8547;
        color: #ff8547;
    }
    .i-tabs-tab-current .i-tabs-tab-title-current,.i-tabs-tab-current .i-tabs-tab-doc{
        color: #ff8547;
    }
    .i-tabs-tab-doc{
        display: inline-block;
        color:#80848f;
        font-size: 12px;
    }
    .i-tabs-tab-bottom{
        position: relative;
        width: 100%;
        bottom: 5px;
        margin-top: 15px;
    }
    .tr{
        position: absolute;
        bottom: 1px;
        right: 0;
    }
    .i-tabs-tab-doc .iconfont{
        vertical-align: middle;
        margin-right: 2px;
    }
    .audio-list{
        white-space:nowrap;
        background-color:#fff;
    }
    ::-webkit-scrollbar {
        width: 0;
        height: 0;
        color: transparent;
    }
    .collect-info{
        position: fixed;
        bottom: 100px;
        right: 0;
        /*padding: 10px;*/
        /*background-color: #fff;*/
        /*border: 1px solid #eee;*/
        /*border-radius: 10px 0 0 10px;*/
        /*font-weight: bold;*/
        /*box-shadow: 1px 1px 2px #ccc;*/
    }
    .mask{
        position: fixed;
        top: 0;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,.5);
        overflow-y: auto;
    }
    .topic{
        position: absolute;
        top: 50%;
        padding: 10px;
        width: 300px;
        box-sizing: border-box;
        background-color: #fff;
        overflow: hidden;
        transform: translate(-50%,-50%);
        left: 50%;
    }
    .topic-frameli{
        text-align: center;
        font-size: 14px;
        margin: 10px;
        margin-bottom: 20px;
    }
    .topic-frameli span{
        color: #fbb561;
        font-size: 14px;
    }
    .entrance-bottom-frame {
        transition: all 0.5s;
        margin-top: 10px;
    }
    .entrance-bottom-frame-line {
        transition: all 0.5s;
    }
    .entrance-bottom-frame-line-title{
        font-size: 12px;
        margin-bottom: 20px;
    }
    .entrance-bottom-frame-line-button{
        font-size: 12px;
        padding: 10px 15px;
        background-color: #f7f7f7;
        border-radius: 20px;
        margin-bottom: 20px;
    }
    .entrance-bottom-frame-line-button.sel{
        color: #ffffff;
        background: #f86d07;
    }
    .topic-btn{
        display: flex;
        text-align: center;
    }
    .topic-btn .btn{
        flex: 1;
        padding: 5px 0;
        margin: 0 20px;
        color: #fff;
        border-radius: 10px;
        font-size: 12px;
    }
    .topic-btn .upper{
        background-color: #3282b8;
    }
    .topic-btn .save{
        background-color: #ff5f40;
    }
    .topic-btn .lower{
        background-color: #24a19c;
    }
    .topic-title{
        position: relative;
    }
    .topic-close{
        position: absolute;
        top: -3px;
        right: 0;
        background-color: #f30;
        color: #fff;
        padding: 2px 5px;
        font-size: 12px;
        border-radius: 5px;
    }
    .interaction{
        position: relative;
        border-bottom:1px dashed #ccc;
        padding-bottom: 5px;
    }
    .interaction-icon{
        vertical-align: top;
        display: inline-block;
    }
    .interaction-icon .iconjiaoyu{
        font-size: 24px;
    }
    .interaction-content{
        display: inline-block;
        padding-left: 20px;
    }
    .interaction-content .inter-txt{
        color: #aaa;
        padding-top: 5px;
    }
    .home{
        color: #fff;
        position: fixed;
        right: 10px;
        bottom: 10px;
        background-color: #fff;
        background: rgba(255,133,71,1);
        border-radius: 50%;
        text-align: center;
        padding: 6px 10px;
    }
    .home view{
        font-size: 10px;
        color: #fff;
    }
    .make-an-appointment{
        position: fixed;
        bottom: 0;
        width: 100%;
        border: 1px solid #ccc;
        background-color: #fff;
        display: flex;
    }
    .share{
        text-align: center;
        display: inline-block;
        border-right: 1px solid #ccc;
        padding: 0 15px;
        line-height: 39px;
        background-color: #fff;
        border-radius:0;
    }
    .share::after{
        content: '';
        width: 0;
        height: 0;
    }
    .trial-class{
        text-align: center;
        display: inline-block;
        border-right: 1px solid #ccc;
        padding: 10px 20px;
    }
    .make-an-appointment-text{
        display: inline-block;
        text-align: center;
        background-color: #FF6600;
        color: #fff;
        border-right: 1px solid #ccc;
        padding: 10px;
        flex: 1;
    }
    .swiper-img{
        height: 100%;
        width: 100%;
    }
    .pdf-content .pdf-text{
        position:absolute;
        bottom:0;
        right:0;
        color:#fff;
        padding:2px 10px;
        background-color:#327CE9;
        font-size:12px;
    }

    .wares-li{
        margin-bottom:10px;
        border-bottom:1px solid #eee;
    }
    .wares-li .wares-top{
        position:relative;
    }
    .wares-top .wares-name{
        display:-webkit-box;
        padding-right:55px;
        -webkit-box-orient:vertical;
        -webkit-line-clamp:2;
        overflow:hidden;
        text-overflow:ellipsis;
        font-weight:bold;
    }
    .wares-top .wares-time{
        position:absolute;
        right:0;
        top:0;
        font-size:12px;
        color:#aaa;
    }
    .wares-li .wares-txt{
        margin:10px 0;
        font-size:12px;
    }
    .wares-img{
        margin-top:10px;
        padding:10px 0;
        border-top:1px dashed #eee;
        text-align:center;
        font-weight:bold;
    }

    .no-list{
        text-align: center;
        width: 100%;
        color: #999;
        font-size: 12px;
    }

    .banner-modal .banner-box {
        background-color: #fff;
        overflow: hidden;
    }
    .banner-modal .modal-top {
        color: #fff;
        font-size: 16px;
    }
    .modal-top .iconfont {
        font-size: 20px;
        margin-top: 20px;
    }
    .modal-btn {
        text-align: center;
        padding: 10px;
    }
    .modal-btn button {
        background-color: #FF6600;
        display: inline-block;
        height: 26px;
        line-height: 26px;
        font-size: 16px;
        color: #ffffff;
    }
    .modal-close {
        position: absolute;
        top: 0;
        right: 0;
        font-size: 20px;
        margin-right: 5px;
    }
    .time-percentage{
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        background: rgba(171,171,171,.2);
    }
    .chapter-data{
        font-weight: bold;
        position: absolute;
        width: 100%;
        left: 0;
        border-left: 5px solid #349bf8;
        padding-left: 5px;
    }
    .flex-direction{
        display: flex;
        flex-direction: column;
    }
    .flex{
        display: flex;
        flex: 1;
        flex-direction: column;
        /* height: 100%; */
        width: 100%;
    }
    .my-work{
        color: #fff;
        position: fixed;
        top: 80%;
        background-color: #327CE9;
        border-radius: 50%;
        text-align: center;
        padding: 5px 11px;
    }
    .my-work .my-work-txt{
        color: #fff;
    }
    .send-chat{
        position: fixed;
        bottom: 0;
        width: 100%;
        padding: 5px;
        background-color: #fff;
        box-sizing: border-box;
        -o-box-sizing: border-box;
        -ms-box-sizing: border-box;
        -moz-box-sizing: border-box;
        -webkit-box-sizing: border-box;
        z-index: 99999;
        height: 42.39px;
    }
    .send-chat input{
        padding: 5px;
        background-color: #f3f3f3;
        padding-right: 47px;
    }
    .chat-content .chat-details{
        width: 100%;
        height: 100%;
        padding: 10px;
        /*overflow-y: auto;*/
        box-sizing: border-box;
        -o-box-sizing: border-box;
        -ms-box-sizing: border-box;
        -moz-box-sizing: border-box;
        -webkit-box-sizing: border-box;
    }
    .send-chat .btn-send{
        position: absolute;
        top: 0;
        right: 0;
        height: 1.4rem;
        margin-right: 5px;
        margin-top: 5px;
        padding: 5px;
        line-height: 1.4rem;
        letter-spacing: 2px;
        border-left: 1px solid #ccc;
    }
    .send-chat .input{
        width: 100%;
        background-color: #f3f3f3;
        height: 32px;
        padding: 5px;
        box-sizing: border-box;
        padding-right: 45px;
    }
    .send-chat .send-chat-input{
        bottom: 0;
        position: absolute;
        top: 5px;
        width: 100%;
        box-sizing: border-box;
        height: 32.38px;
        padding-right: 57px;
    }

    .mlf15{
        margin-left: -12.5px;
    }
    .ks-question{
        font-weight: bold;
        padding: 10px;
    }
    .ks-user{
        display: flex;
        padding: 0 10px 10px 10px;
    }
    .ks-user-logo{
        margin-right: 15px;
    }
    .ks-user-img{
        width: 25px;
        border-radius: 50%;
    }
    .ks-user-col{
        font-size: 12px;
        color: #999;
        line-height: 25px;
    }

    .ks-info{
        margin-top: 30px;
        display: flex;
    }
    .ks-info .ks-info-col{
        flex: 1;
        text-align: center;
    }
    .ks-info-col .ks-info-number{
        font-size: 22px;
        font-weight: bold;
    }
    .ks-info-col .ks-info-txt{
        font-size: 12px;
    }
    .bj{
        height: 10px;
        width: 100%;
        background-color: #f8f8f8;
        margin: 10px 0;
    }
    .ks-content{
        margin-top: 30px;
        padding: 10px;
        margin-bottom: 50px;
    }
    .ks-btn{
        position: fixed;
        bottom: 0;
        background-color: #fff;
        width: 100%;
        padding: 5px 10px;
        box-sizing: border-box;
    }
    .ks-btn-col{
        color: #fff;
        background-color: #327CE9;
        padding: 8px;
        text-align: center;
        border-radius: 20px;
    }
    .topic-title .yes,.topic-title .no{
        font-size: 18px;
    }
    .topic-title .yes{
        color: #44b549;
    }
    .topic-title .no{
        color: #c9302c;
    }
    .align-c{
        text-align: center;
    }
</style>

<style scoped>
    .video-player{
        height: 100%;
    }
    .video-content >>> .vjs-custom-skin > .video-js{
        height: 100% !important;
    }
    .audio-list{
        white-space:nowrap;
        background-color:#fff;
        overflow-x: scroll;
        width: 100%;
    }
    .i-tabs-tab {
        flex:1;
        display:flex;
        width:100%;
        -webkit-box-pack:center;
        justify-content:center;
        -webkit-box-align:center;
        align-items:center;
        -webkit-box-orient:vertical;
        -webkit-box-direction:normal;
        flex-direction:column;
        position:relative
    }
    .i-tabs-tab-bar {
        display:none;
        width:100%;
        height:2px;
        background:0 0;
        position:absolute;
        bottom:0;
        left:0;
        background:#2d8cf0
    }
    .i-tabs-tab-title {
        font-size:14px;
        box-sizing:border-box;
        color:#80848f;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
        white-space: normal;
        height: 38px;
    }
    .i-tabs-tab-title-current {
        color:#2d8cf0
    }
    .i-tabs-tab-scroll {
        display: inline-block;
        width: 140px;
        border: 1px solid #eee;
        margin: 10px;
        height: 80px;
        padding: 5px;
        box-sizing: border-box;
        border-radius: 5px;
        vertical-align: middle;
        overflow: hidden;
    }
    .i-tabs-tab-current {
        background:#fff;
        border: 1px solid #ff8547;
        color: #ff8547;
    }
    .i-tabs-tab-current .i-tabs-tab-title-current,.i-tabs-tab-current .i-tabs-tab-doc{
        color: #ff8547;
    }
    .i-tabs-tab-doc{
        display: inline-block;
        color:#80848f;
        font-size: 12px;
    }
    .i-tabs-tab-bottom{
        position: relative;
        width: 100%;
        bottom: 5px;
        margin-top: 15px;
    }
    .tr{
        font-size: 10px;
        position: absolute;
        bottom: 1px;
        right: 0;
    }
    .i-tabs-tab-doc .iconfont{
        vertical-align: middle;
        margin-right: 2px;
    }
    .taolun-btn{
        padding: 5px 10px;
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        max-width: 480px;
        margin: 0 auto;
        width: 100%;
        box-sizing: border-box;
        background-color: #fff;
        display: flex;
        align-items: center;
        justify-content: space-between;
        box-shadow: -1px -1px 3px #e6e2e2;
    }

    .taolun-btn-text{
        flex: 6;
    }
    .taolun-btn-text .van-field{
        background-color: #f9f9f9;
        border-radius: 30px;
    }
    .taolun-discuss-module{
        padding-left: 20px;
        flex: 1;
    }
    .taolun-favor-module{
        flex: 1;
    }
    .van-info{
        color: #fff;
    }
    .taolun-text-wrap{
        padding: 15px 15px 0px 15px;
    }
    .taolun-text-head-title{
        font-size: 15px;
        font-weight: 500;
    }
    .taolun-text-head{
        display: flex;
        justify-content: space-between;
    }
    .van-button__text{
        color: #fff;
    }
    .taolun-text-bottom{
        display: flex;
        justify-content: space-between;
    }
    .taolun-text-bottom-left{
        display: flex;
        justify-content: space-between;
    }
    .size25{
        font-size: 25px;
    }
    .size21{
        font-size: 21px;
    }
    .mr5{
        margin-left: 5px;
    }
    .taolun_discuss_list_zone{
        display: flex;
        flex-direction: column;
        flex: 1;
        height: 100%;
        width: 100%;
    }
    .taolun_discuss_list{
        display: flex;
        /*flex-direction: column;*/
        flex: 1;
        height: 100%;
        width: 100%;
    }
    .taolun-text-right{
        background-color: #f8f9fb;
        padding: 0px 5px;
        border-radius: 20px;
        height: 24px;
        color: #ff8547;
        display: flex;
        align-items: center;
    }
    .right-privacy{
        color: #434247 !important;
    }
    .taolun-image-upload{
        padding: 10px 5px 10px;
    }
    .taolun-image-upload >>> .van-uploader__upload{
        display: none !important;
    }
    .van-nav-bar{
        height: 46px;
        line-height: 46px;
    }
    .table-content-zhangjieyugao{
        padding-bottom: 60px;
    }
    .audio_detail_content >>> img{
        display: block;
        width: 100%;
    }
    
</style>

<!-- video 样式 -->
<style scoped>

    .video-content >>> .video-js .vjs-volume-panel{
        display: none;
    }
    .video-content >>> .video-js .vjs-big-play-button{
        height: 50px !important;
        width: 50px;
        margin-left: -25px;
        border-radius: 50%;
        border: 0;
        line-height: 50px !important;
    }
    .video-content >>> .video-js{
        /* padding-top: 43%; */
    }
</style>
